module.exports = __webpack_public_path__ + "img/folder.38608be1.svg";